import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Text } from '@zillow/constellation';
import PropTypes from 'prop-types';

var _excluded = ["fontColor", "fontSize", "fontWeight", "fontFamily", "children"];

/**
 * Renders an inline text component with customizable font properties.
 *
 * @param {string} fontColor - The color of the text
 * @param {string} fontSize - The size of the text
 * @param {string} fontWeight - The weight of the text
 * @param {string} fontFamily - The font family of the text
 * @param {ReactNode} children - The content to be displayed
 * @param {...any} rest - Any other props to be spread
 * @return {ReactNode} The inline text component with specified font properties
 */
var TextInline = function TextInline(_ref) {
  var fontColor = _ref.fontColor,
    fontSize = _ref.fontSize,
    fontWeight = _ref.fontWeight,
    fontFamily = _ref.fontFamily,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Text, _extends({
    fontColor: fontColor || 'inherit',
    style: {
      fontSize: fontSize || 'inherit',
      fontWeight: fontWeight || 'inherit',
      fontFamily: fontFamily || 'inherit'
    }
  }, rest), children);
};
TextInline.propTypes = process.env.NODE_ENV !== "production" ? {
  fontColor: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  fontFamily: PropTypes.string
} : {};
var TextInline$1 = TextInline;

export { TextInline$1 as default };
